document.addEventListener("DOMContentLoaded", function () {
  let amRoutineData = {};
  let pmRoutineData = {};
  let routineSteps = [];
  let routineGenerated = false;

  //Banner button trigger
  document.querySelectorAll(".banner-btn").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.querySelector(".routine-step");

      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Accordion (smooth + multi-open + correct arrows)
  const items = document.querySelectorAll(".accordion-item");

  items.forEach((item, index) => {
    const header = item.querySelector(".accordion-header");
    const content = item.querySelector(".accordion-content");
    const inner = item.querySelector(".accordion-inner");

    // initial state
    if (index === 0) {
      item.classList.add("active");
      content.style.maxHeight = inner.scrollHeight + "px";
    } else {
      content.style.maxHeight = "0px";
    }

    header.addEventListener("click", (e) => {
      e.preventDefault();

      const isOpen = item.classList.contains("active");

      // 🔴 CLOSE ALL first
      items.forEach((i) => {
        const c = i.querySelector(".accordion-content");
        const inn = i.querySelector(".accordion-inner");

        if (i.classList.contains("active")) {
          c.style.maxHeight = inn.scrollHeight + "px";
          requestAnimationFrame(() => {
            c.style.maxHeight = "0px";
          });
        }

        i.classList.remove("active");
      });

      // 🟢 OPEN clicked one (only if it was closed)
      if (!isOpen) {
        item.classList.add("active");
        content.style.maxHeight = inner.scrollHeight + "px";
      }
    });
  });

  // Selection count
  const checkboxes = document.querySelectorAll(".product-checkbox");
  const selectedCount = document.getElementById("selected-count");
  const cartCount = document.getElementById("cart-count");
  const generateBtn = document.getElementById("generateRoutineBtn");
  const clearAllBtn = document.getElementById("clearAllBtn");

  const duplicategenerateBtn = document.getElementById("duplicateGenerateRoutineBtn");
  const duplicateclearAllBtn = document.getElementById("duplicateClearBtn");

  function updateCount() {
    const checked = document.querySelectorAll(".product-checkbox:checked");

    // total count
    selectedCount.textContent = checked.length;
    cartCount.textContent = checked.length;

    // enable/disable generate button
    if (checked.length > 0 && !routineGenerated) {
      generateBtn.disabled = false;
      generateBtn.classList.add("enabled");
      clearAllBtn.disabled = false;
      clearAllBtn.classList.add("enabled");
      
      duplicategenerateBtn.disabled = false;
      duplicategenerateBtn.classList.add("enabled");
      duplicateclearAllBtn.disabled = false;
      duplicateclearAllBtn.classList.add("enabled");

      

    } else {
      duplicategenerateBtn.disabled = true;
      duplicategenerateBtn.classList.remove("enabled");
      duplicateclearAllBtn.disabled = true;
      duplicateclearAllBtn.classList.remove("enabled");

      generateBtn.disabled = true;
      generateBtn.classList.remove("enabled");
      clearAllBtn.disabled = true;
      clearAllBtn.classList.remove("enabled");

      document.querySelectorAll(".collection-count").forEach(el => {
        el.textContent = 0;
      });
    }

    // reset all collection counts
    document.querySelectorAll(".accordion-item").forEach(item => {
      const countEl = item.querySelector(".collection-count");
      const wrapper = item.querySelector(".collection-count-wrapper");

      if (countEl) countEl.textContent = 0;
      if (wrapper) wrapper.style.display = "none";
    });

    // update per collection
    checked.forEach(cb => {
      const item = cb.closest(".accordion-item");
      const countEl = item.querySelector(".collection-count");
      const wrapper = item.querySelector(".collection-count-wrapper");

      if (countEl && wrapper) {
        const newCount = parseInt(countEl.textContent) + 1;
        countEl.textContent = newCount;

        if (newCount > 0) {
          wrapper.style.display = "inline";
        }
      }
    });
  }

  checkboxes.forEach((cb) => {
    cb.addEventListener("change", () => {
      routineGenerated = false; // 👈 important
      updateCount();
    });
  });

  // Search products
  const routineHeader = document.querySelector(".routine-header");
  const searchIcon = routineHeader.querySelector(".search-icon");
  const searchCloseIcon = routineHeader.querySelector(".search-close-icon");

  // searchIcon.addEventListener("click", () => {
  //   routineHeader.classList.toggle("search-active");
  //   document.getElementById('product-search').focus();
  // });
  searchIcon.addEventListener("click", (e) => {
    e.stopPropagation(); // prevent triggering document click
    routineHeader.classList.toggle("search-active");
    document.getElementById('product-search').focus();
  });

  document.addEventListener("click", (e) => {
    const isClickInside = routineHeader.contains(e.target);

    if (!isClickInside) {
      routineHeader.classList.remove("search-active");
    }
  });  

  function handleSearch() {
    const query = searchInput.value.toLowerCase().trim();
    const accordions = document.querySelectorAll(".accordion-item");

    accordions.forEach((item) => {
      const products = item.querySelectorAll(".product-card");
      const noMsg = item.querySelector(".no-products-message");
      const content = item.querySelector(".accordion-content");
      const inner = item.querySelector(".accordion-inner");

      let visibleCount = 0;

      products.forEach((product) => {
        const title = product.dataset.title;

        if (!query || title.includes(query)) {
          product.style.display = "";
          visibleCount++;
        } else {
          product.style.display = "none";
        }
      });

      if (noMsg) {
        noMsg.style.display = visibleCount === 0 ? "block" : "none";
      }

      item.style.display = "";
      item.classList.add("active");
      content.style.maxHeight = inner.scrollHeight + "px";
    });

    if (!query) {
      document.querySelectorAll(".accordion-item").forEach((item, index) => {
        const content = item.querySelector(".accordion-content");
        const inner = item.querySelector(".accordion-inner");

        item.classList.remove("active");

        if (index === 0) {
          item.classList.add("active");
          content.style.maxHeight = inner.scrollHeight + "px";
        } else {
          content.style.maxHeight = "0px";
        }
      });
    }
  }

  const searchInput = document.getElementById("product-search");

  // events
  searchInput.addEventListener("input", handleSearch);

  searchCloseIcon.addEventListener('click', () => {
    routineHeader.classList.remove("search-active");
    searchInput.value = '';
    handleSearch(); // ✅ direct call
  });

  // Add to cart
  const addToCartBtn = document.getElementById("addToCartBtn");
  addToCartBtn.addEventListener("click", function () {
    const checked = document.querySelectorAll(".product-checkbox:checked");

    if (!checked.length) {
      alert("Please select at least one product");
      return;
    }

    // Activate loading state
    addToCartBtn.classList.add("loading");
    addToCartBtn.disabled = true;

    const items = [];

    // Get selected routine name
    const activeRoutine = document.querySelector(".curated-items .item.active");
    const routineName =
        activeRoutine?.querySelector(".face")?.dataset?.title ||
        "Custom Routine";
    
    console.log({routineName});

    checked.forEach((cb) => {
      items.push({
        id: cb.value,
        quantity: 1,
        properties: {
          Routine: routineName
        }
      });
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
       body: JSON.stringify({
        items,
        // attributes: {
        //   Routine: routineName
        // }
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // Trigger cart refresh/drawer
        document.dispatchEvent(new CustomEvent("cart:refresh"));

        const klaviyoEmail = window.customerEmail || window.routineCustomerEmail;
        if (klaviyoEmail) {
          updateRoutineCartStatus(klaviyoEmail);
        }

        // Reset selections
        document
          .querySelectorAll(".product-checkbox")
          .forEach((cb) => (cb.checked = false));

        document.getElementById("selected-count").textContent = 0;
        document.getElementById("cart-count").textContent = 0;
        document.querySelectorAll(".collection-count").forEach(el => {
          el.textContent = 0;
        });
        document.querySelectorAll(".collection-count-wrapper").forEach(el => {
          el.style.display = "none";
        });
        routineGenerated = false;
      })
      .catch((err) => {
        console.error(err);
        alert("Something went wrong");
      })
      .finally(() => {
        // Remove loading state
        addToCartBtn.classList.remove("loading");
        //addToCartBtn.disabled = true;
      });
  });

  //Toggle AM/PM
  const section = document.querySelector(".section-routine-step");
  const buttons = section.querySelectorAll(".toggle__btn");
  const container = section.querySelector(".step-right-container_active");
  const rightContainer = section.querySelector(".routine-step");
  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      buttons.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");
      if (this.classList.contains("moon-btn")) {
        rightContainer.classList.add("show-pm");
      } else {
        rightContainer.classList.remove("show-pm");
      }
    });
  });

  function sortRoutineData(routineData) {
    Object.keys(routineData).forEach(step => {
      routineData[step].sort((a, b) => {
        // Keep 0 at the top
        if (a.routine_sort_index === 0 && b.routine_sort_index !== 0) return -1;
        if (b.routine_sort_index === 0 && a.routine_sort_index !== 0) return 1;

        // Otherwise normal ascending sort
        return a.routine_sort_index - b.routine_sort_index;
      });
    });
  }
  
  //Generate routine
  function generateRoutine(){
    const checked = document.querySelectorAll(".product-checkbox:checked");

    amRoutineData = {};
    pmRoutineData = {};

    checked.forEach((cb) => {
      const card = cb.closest(".product-card");

      const usage = (card.dataset.usage || "").toLowerCase();
      const step = parseInt(card.dataset.step) || 0;

      const productData = {
        id: card.dataset.id,
        variant_id: card.dataset.variant_id,
        step,
        subtitle: card.dataset.subtitle || "",
        description: card.dataset.description || "",
        image: card.dataset.image || "",
        title: card.dataset.product_title,
        price: card.dataset.price || "",
        product_url: card.dataset.product_url || "",
        routine_sort_index: parseInt(card.dataset.routine_sort_index) || 0
      };

      // ✅ AM
      if (usage === "am" || usage === "both") {
        if (!amRoutineData[step]) amRoutineData[step] = [];
        amRoutineData[step].push(productData);
      }

      // ✅ PM
      if (usage === "pm" || usage === "both") {
        if (!pmRoutineData[step]) pmRoutineData[step] = [];
        pmRoutineData[step].push(productData);
      }
    });

    // Apply sorting
    sortRoutineData(amRoutineData);
    sortRoutineData(pmRoutineData);

    //const steps = JSON.parse(document.getElementById('routineStepsData').textContent);
    routineSteps = JSON.parse(
      document.getElementById("routineStepsData").textContent,
    );
    routineSteps.sort((a, b) => a.step - b.step);

    renderRoutine("am-routine", routineSteps, amRoutineData);
    renderRoutine("pm-routine", routineSteps, pmRoutineData);

    // ✅ enable right container
    document.querySelectorAll(".right-container").forEach((el) => {
      el.classList.remove("disabled");
    });

    addToCartBtn.disabled = false;
     document.querySelector(".ampm-info").style.display = "block";
    // optional scroll
    //   document.getElementById('routine-output').scrollIntoView({
    //       behavior: 'smooth'
    //   });

    if (window.matchMedia("(max-width: 768px)").matches) {
      document
        .querySelector(".right-container")
        .classList.remove("hidden-mobile");
      document.querySelector(".left-container").classList.add("hidden-mobile");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    routineGenerated = true;
    generateBtn.disabled = true;
    generateBtn.classList.remove("enabled");

    if (window.customerEmail) {
      updateKlaviyoProfile(window.customerEmail);
    }
  }

  generateBtn.addEventListener("click", function () {
    if (this.disabled) return;

    generateRoutine();
    // removed title inside .am-info h5 with span
      document.querySelectorAll(".am-info h5, .pm-info h5").forEach(heading => {
        heading.querySelector(".curated-title")?.remove();
      });
  });

  //Clear all
  clearAllBtn.addEventListener("click", function () {
    console.log('çlear');
    // uncheck all
    document.querySelectorAll(".product-checkbox").forEach(cb => {
      cb.checked = false;
    });

    // reset counts
    selectedCount.textContent = 0;
    cartCount.textContent = 0;

    document.querySelectorAll(".collection-count").forEach(el => {
      el.textContent = 0;
    });
    document.querySelectorAll(".collection-count-wrapper").forEach(el => {
      el.style.display = "none";
    });

    // disable buttons
    generateBtn.disabled = true;
    generateBtn.classList.remove("enabled");

    clearAllBtn.disabled = true;
    clearAllBtn.classList.remove("enabled");

    addToCartBtn.disabled = true;
    document.querySelector(".ampm-info").style.display = "none";

    routineGenerated = false;

    // OPTIONAL: clear generated routines
    document.getElementById("am-routine").innerHTML = "";
    document.getElementById("pm-routine").innerHTML = "";

    // OPTIONAL: disable right container again
    document.querySelectorAll(".right-container").forEach(el => {
      el.classList.add("disabled");
    });

  });

  function getOrdinal(n) {
    if (n % 100 >= 11 && n % 100 <= 13) return n + "th";
    switch (n % 10) {
      case 1: return n + "st";
      case 2: return n + "nd";
      case 3: return n + "rd";
      default: return n + "th";
    }
  }

  function renderRoutine(containerId, allSteps, stepMap) {
    const container = document.getElementById(containerId);

    // clear old
    container.innerHTML = "";

    const wrapper = document.createElement("div");
    wrapper.className = "step-right-container step-right-container_active";

    allSteps.forEach((stepObj, index) => {
      const stepNumber = parseInt(stepObj.step);
      const stepTitle = stepObj.step_title;

      const products = stepMap[stepNumber] || [];

      const stepContent = document.createElement("div");
      stepContent.className = "step-right-content";

      let html = `
              <h5 class="step-label">${stepTitle}</h5>
          `;

      if (products.length) {
        products.forEach((product, pIndex) => {
          html += `
            <div class="routine-step__content">
              <div class="routine-step__left">
                <div class="product-image">
                  <a href="${product.product_url}" target="_blank"><img src="${product.image}" alt="${product.title}"></a>
                </div>
              </div>

              <div class="routine-step__right">
                ${stepNumber === 2 ? `<p class="description">${getOrdinal(pIndex + 1)} Serum</p>` : ""}
                <h4 class="title"><a href="${product.product_url}" target="_blank">${product.title}</a></h4>
                ${product.subtitle ? `<p class="description">${product.subtitle}</p>` : ""}
                ${product.price ? `<p class="description routine-price">${product.price}</p>` : ""}
                ${product.description ? `<p class="description">${product.description}</p>` : ""}
              </div>
            </div>
          `;
        });
      } else {
        // ✅ empty step
        html += `
                  <div class="routine-step__content">
                      <div class="routine-step__right">
                          <p class="description">${stepObj.no_product_message}</p>
                      </div>
                  </div>
              `;
      }

      // divider (not last step)
      if (index !== allSteps.length - 1) {
        html += `<div class="routine-step__divider"></div>`;
      }

      stepContent.innerHTML = html;
      wrapper.appendChild(stepContent);
    });

    container.appendChild(wrapper);
  }

  //Klaviyo formatter
  function buildRoutineForKlaviyo(steps, stepMap) {
    return steps.map((stepObj) => {
      const stepNumber = parseInt(stepObj.step);
      const products = stepMap[stepNumber] || [];

      return {
        step: stepNumber,
        step_title: stepObj.step_title,
        products: products.map((p) => ({
          id: p.id,
          image: p.image,
          title: p.title,
          subtitle: p.subtitle,
          price: p.price,
          description: p.description,
          product_url: p.product_url
        })),
      };
    });
  }

  //Email button logic
  const emailBtn = document.getElementById("emailRoutineBtn");
  const popup = document.getElementById("namePopup");
  const body = document.body;

  emailBtn.addEventListener("click", function () {
    if (!routineSteps.length) {
      alert("Please generate routine first");
      return;
    }

    // ✅ Logged-in user → send
    if (window.customerEmail) {
      sendToKlaviyo(window.customerEmail);
      return;
    }

    // ❗ Guest → open popup
    popup.classList.remove("remove-popup");
    body.classList.add("pop-up-open");
  });
  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.classList.add("remove-popup");
      body.classList.remove("pop-up-open");
    }
  });

  //Popup form submit
  const form = document.querySelector("#namePopup form");
  const button = form.querySelector("button");

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const emailInput = form.querySelector('input[name="customer_email"]');
    const consentCheckbox = form.querySelector("#emailConsent");

    const email = emailInput.value.trim();
    const consent = consentCheckbox.checked;

    if (!email) return;

    window.routineCustomerEmail = email;

    button.classList.add("loading");

    sendToKlaviyo(email, consent);

    // close popup
    popup.classList.add("remove-popup");
    document.body.classList.remove("pop-up-open");

    form.reset();
    button.classList.remove("loading");
  });

  function generateCombinedCartUrl(amRoutineData, pmRoutineData) {
    const variantSet = new Set();

    function collect(data) {
      Object.values(data).forEach(stepProducts => {
        stepProducts.forEach(product => {
          if (product.variant_id) {
            variantSet.add(product.variant_id);
          }
        });
      });
    }

    collect(amRoutineData);
    collect(pmRoutineData);

    const items = Array.from(variantSet).map(
      id => `${id}:1`
    );

    if (!items.length) return "";

    const activeRoutine = document.querySelector(
      ".curated-items .item.active"
    );

    const routineName =
      activeRoutine?.querySelector(".face")?.dataset?.title ||
      "Custom Routine";

    const baseUrl = window.location.origin;

    return `${baseUrl}/cart/${items.join(",")}?attributes[Routine]=${encodeURIComponent(routineName)}`;
  }

  //Send to Klaviyo
  function sendToKlaviyo(email, consent = false) {
    const amRoutine = buildRoutineForKlaviyo(routineSteps, amRoutineData);
    const pmRoutine = buildRoutineForKlaviyo(routineSteps, pmRoutineData);
    const cartUrl = generateCombinedCartUrl(amRoutineData, pmRoutineData);

    // ✅ Update customer profile properties
    updateKlaviyoProfile(email);

    window._learnq = window._learnq || [];

    // ✅ Always identify
    // window._learnq.push(['identify', {
    //   $email: email
    // }]);

    // ✅ Track routine event (always)
    window._learnq.push([
      'track',
      'Routine Email Trigger',
      {
        email: email,
        consent: consent,
        am_routine: amRoutine,
        pm_routine: pmRoutine,
        cart_url: cartUrl
      }
    ]);

    // ✅ Track subscription ONLY if consent given
    if (consent) {
      subscribeToKlaviyoList(email);
    }

    console.log("Klaviyo payload:", {
      email,
      consent,
      am_routine: amRoutine,
      pm_routine: pmRoutine,
      cart_url: cartUrl
    });

    showSuccessMessage();
  }

  function subscribeToKlaviyoList(email) {
    const form = document.getElementById("klaviyoForm");

    if (!form) return;

    const companyId = form.dataset.company_id;
    const listId = form.dataset.list_id;

    if (!companyId || !listId) {
      console.error("Missing Klaviyo company_id or list_id");
      return;
    }

    fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2023-10-15"
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      })
    })
    .then(res => {
      if (!res.ok) throw new Error(`Subscription failed: ${res.status}`);
      return (res.status === 202 || res.status === 204) ? null : res.json();
    })
    .then(() => {
      console.log("Klaviyo subscription success");
    })
    .catch(err => {
      console.error("Klaviyo subscription error:", err);
    });
  }

  //Success message
  function showSuccessMessage() {
    const successMsg = document.querySelector(".klaviyo-success-msg");
    if (!successMsg) return;

    successMsg.style.display = "flex";

    setTimeout(() => {
      successMsg.style.display = "none";
    }, 4000);
  }

  function getRoutineMeta() {
    const activeRoutine = document.querySelector(".curated-items .item.active");
    const curatedTitle =
      activeRoutine?.querySelector(".face")?.dataset?.title || "";

    return {
      routine_type: curatedTitle
        ? "Curated Routine"
        : "Custom Routine",

      selected_routine_name: curatedTitle || "Custom Routine"
    };
  }

  //Build customer properties for Klaviyo
  function buildCustomerProperties() {
    const checked = document.querySelectorAll(".product-checkbox:checked");

    const selectedProducts = [];
    const selectedCategories = new Set();
    const routineStepsCovered = new Set();

    checked.forEach((cb) => {
      const card = cb.closest(".product-card");

      selectedProducts.push({
        title: card.dataset.product_title || "",
        sku: card.dataset.sku || "",
      });

      // category / collection
      if (card.dataset.category) {
        selectedCategories.add(card.dataset.category);
      }

      // step
      if (card.dataset.step_title) {
        routineStepsCovered.add(card.dataset.step_title.trim());
      }
    });

    // AM products
    const amProducts = [];
    Object.values(amRoutineData).forEach(products => {
      products.forEach(product => {
        amProducts.push(product.title);
      });
    });

    // PM products
    const pmProducts = [];
    Object.values(pmRoutineData).forEach(products => {
      products.forEach(product => {
        pmProducts.push(product.title);
      });
    });

    // Missing steps
    const allSteps = routineSteps
      .map(step => step?.step_title?.trim())
      .filter(Boolean);
    const coveredSteps = Array.from(routineStepsCovered)
      .map(step => step?.trim())
      .filter(Boolean);
    const missingSteps = allSteps.filter(
      step => !coveredSteps.includes(step)
    );

    const routineMeta = getRoutineMeta();

    console.log("allSteps", allSteps);
    console.log("coveredSteps", coveredSteps);
    console.log("missingSteps", missingSteps);
    console.log("routineMeta", routineMeta);

    return {
      selected_products: selectedProducts.map(p => p.title),
      selected_skus: selectedProducts.map(p => p.sku),
      number_of_products_selected: selectedProducts.length,
      categories_selected: Array.from(selectedCategories),
      am_products: amProducts,
      pm_products: pmProducts,
      routine_steps_covered: Array.from(routineStepsCovered),
      missing_steps: missingSteps,
      routine_type: routineMeta.routine_type,
      selected_routine_name: routineMeta.selected_routine_name,
      routine_generated_at: new Date().toISOString()
    };
  }

  // Update Klaviyo Profile
  function updateKlaviyoProfile(email) {
    const customerProperties = buildCustomerProperties();

    window._learnq = window._learnq || [];

    window._learnq.push([
      'identify',
      {
        $email: email,
        ...customerProperties
      }
    ]);

    console.log("Klaviyo profile updated:", {
      email,
      ...customerProperties
    });
  }

  function updateRoutineCartStatus(email) {
    window._learnq = window._learnq || [];

    window._learnq.push([
      'identify',
      {
        $email: email,
        added_to_cart_from_routine: true,
        last_routine_add_to_cart_at: new Date().toISOString()
      }
    ]);

    console.log("Routine cart status updated");
  }

  document.querySelectorAll(".show-step1").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (window.matchMedia("(max-width: 767px)").matches) {

        const leftContainer = document.querySelector(".left-container");

        leftContainer.classList.remove("hidden-mobile");
        document.querySelector(".main-first").classList.add("hidden-mobile");

        // ✅ FIX: recalculate accordion heights AFTER it becomes visible
        setTimeout(() => {
          document.querySelectorAll(".accordion-item.active").forEach(item => {
            const content = item.querySelector(".accordion-content");
            const inner = item.querySelector(".accordion-inner");

            content.style.maxHeight = inner.scrollHeight + "px";
          });
        }, 50); // small delay is key
      }
    });
  });

  document.querySelectorAll(".step-back").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (window.matchMedia("(max-width: 767px)").matches) {
        const left_container = document.querySelector(".left-container");
        left_container.classList.remove("hidden-mobile");
        // document.querySelector(".right-container").classList.add("hidden-mobile");
        left_container.classList.add("mobile-popup");
        document.body.classList.add("mobile-pop-overlay"); 
        
        if (left_container.classList.contains("remove-left") ) {
           left_container.classList.remove("remove-left");
        }
      }
    });
  });

  document.getElementById("closePopupBtn").addEventListener("click", function (e) {
  e.stopPropagation();

  const checked = document.querySelectorAll(".product-checkbox:checked");
  const left_container = document.querySelector(".left-container");
  const right_container = document.querySelector(".right-container");


  left_container?.classList.remove("mobile-popup");
  left_container?.classList.add("remove-left");

  document.body.classList.remove("mobile-pop-overlay");

  if (checked.length === 0) {
    console.log("no checkbox selected");
    left_container?.classList.remove("mobile-popup");
    left_container?.classList.remove("remove-left");
    left_container?.classList.remove("hidden-mobile");

    right_container?.classList.add("hidden-mobile")
  } else {
    console.log("checkbox selected");
  }
});

document.addEventListener("click", function (e) {
  const container = document.querySelector(".left-container");

    if (e.target.closest("#generateRoutineBtn")) {
      container?.classList.remove("mobile-popup");
      container?.classList.add("remove-left");

      document.body.classList.remove("mobile-pop-overlay");
      return; 
    }

    if (
      container &&
      container.classList.contains("mobile-popup") &&
      !container.contains(e.target)
    ) {
      container.classList.remove("mobile-popup");
      container.classList.add("remove-left");

      document.body.classList.remove("mobile-pop-overlay");
    }
  });

  document.querySelectorAll(".routine-actions .generate-routine-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.getElementById("generateRoutineBtn")?.click();
    });
  });

  document.querySelectorAll(".routine-actions .clear-all-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.getElementById("clearAllBtn")?.click();
    });
  });

  //Curated Routine
  document.querySelectorAll(".curated-items .item").forEach(item => {
    item.addEventListener("click", () => {
      // ✅ Remove active from all items
      document.querySelectorAll(".curated-items .item").forEach(el => {
        el.classList.remove("active");
      });

      item.classList.add("active");
      document.getElementById("clearAllBtn")?.click();
      
      const face = item.querySelector(".face");
      const variantIds = (face.dataset.variant_ids || "").split(",");
      
      // Get data-title
      const title = face.dataset.title || "";

      // Append title inside .am-info h5 with span
      document.querySelectorAll(".am-info h5, .pm-info h5").forEach(heading => {
        heading.querySelector(".curated-title")?.remove();
        heading.innerHTML += ` <span class="curated-title">: ${title}</span>`;
      });

      applyCuratedRoutine(variantIds);
      generateRoutine();
      document.body.classList.remove("mobile-pop-overlay");
    });
  });

  function applyCuratedRoutine(variantIds) {
    const allCards = document.querySelectorAll(".product-card");

    allCards.forEach(card => {
      const vid = card.dataset.variant_id;
      if (variantIds.includes(vid)) {
        const checkbox = card.querySelector("input[type='checkbox']");
        if (checkbox) {
          checkbox.checked = true;

          // Trigger any existing logic tied to change
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }
});